<template>
    <b-form @submit.stop.prevent="createOrder">
        <b-form-group
            id="input-group-type"
            label="Type:"
            label-for="input-type"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-select
                id="input-type"
                v-model="model.order_type_id"
                :options="orderTypes | mapOptions"
                required
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Order Type</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-form-group>

        <b-form-group
            id="input-group-customer"
            label="Customer:"
            label-for="input-customer"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <customer-type-ahead
                v-model="model.customer_id"
                @set-customer="customer = $event"
                required
            ></customer-type-ahead>
        </b-form-group>

        <b-form-row>
            <b-col offset="3">
                <b-form-checkbox
                    id="checkbox-template"
                    v-model="isTemplate"
                    name="checkbox-template"
                    :value="true"
                    :unchecked-value="false"
                >
                    Use Template?
                </b-form-checkbox>
            </b-col>
        </b-form-row>

        <select-order-template
            v-if="isTemplate"
            v-model="model.order_template_id"
            :order-type-id="model.order_type_id"
        ></select-order-template>

        <b-card v-if="isTemplate && model.customer_id">
            <view-assets
                v-model="model.assets"
                :customer-id="model.customer_id"
            />
        </b-card>

        <b-form-group
            id="input-group-description"
            label="Description:"
            label-for="input-description"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-textarea
                id="input-description"
                v-model="model.description"
                placeholder="Brief description of order..."
                rows="3"
                max-rows="4"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            id="input-group-driver"
            label="Assigned To:"
            label-for="input-driver"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-select
                id="input-driver"
                v-model="model.driver_id"
                :options="drivers | mapOptions(true)"
                required
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Officer</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-form-group>

        <b-form-group
            id="input-group-reference_no"
            label="Reference No:"
            label-for="input-reference_no"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-input
                id="input-reference_no"
                v-model="model.reference_no"
                type="text"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-date"
            label="Due Date:"
            label-for="input-date"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-input
                id="input-date"
                v-model="model.date"
                type="date"
                required
            ></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-time"
            label="Due Time:"
            label-for="input-time"
            label-class="font-weight-bold pt-0"
            label-cols="3"
        >
            <b-form-input
                id="input-time"
                v-model="model.time"
                type="time"
                required
            ></b-form-input>
        </b-form-group>

        <b-form-checkbox
            id="checkbox-signature"
            v-model="model.signature"
            name="checkbox-signature"
            :value="true"
            :unchecked-value="false"
        >
            Require Signature
        </b-form-checkbox>

        <div class="text-right">
            <b-button
                class="my-4"
                variant="warning"
                :disabled="submitting ? true : false"
                @click="cancel()"
                >Cancel</b-button
            >
            <b-button
                type="submit"
                class="my-4"
                variant="primary"
                :disabled="submitting ? true : false"
                >Create</b-button
            >
        </div>
    </b-form>
</template>

<script>
import SelectOrderTemplate from '@/components/SelectOrderTemplate'
import orderHelperMixins from '@/mixins/orderHelperMixins'
import popupMixins from '@/mixins/popupMixins'
import CustomerTypeAhead from '@/components/CustomerTypeAhead.vue'
import ViewAssets from '@/components/ViewAssets'
const scheduledDate = new Date(Date.now() + 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
const scheduledTime = '09:30:00'

export default {
    name: 'create-order-form',
    components: {
        ViewAssets,
        CustomerTypeAhead,
        SelectOrderTemplate,
    },
    mixins: [popupMixins, orderHelperMixins],
    props: [],
    data: () => {
        return {
            customer: {},
            isTemplate: false,
            model: {
                order_type_id: null,
                customer_id: null,
                description: null,
                driver_id: null,
                order_template_id: null,
                date: scheduledDate,
                time: scheduledTime,
                signature: false,
                assets: [],
                delivery_location_section_id: null,
                //  lat: 18.003713067980094,
                //  long: -76.7883610725403,
            },
            category_id: null,

            submitting: false,
            hasErrors: false,
        }
    },
    filters: {
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },
    created() {
        this.model.date = scheduledDate
        console.log('scheduledDate', scheduledDate)
    },
    mounted() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('orders/fetchDrivers')
        this.$store.dispatch('assets/fetch')
    },
    computed: {
        orderTypes() {
            const orderTypes = this.$store.state.orderType.items
            console.log('orderTypes', orderTypes)
            return orderTypes
        },
        drivers() {
            return this.$store.state.orders.drivers
        },
    },
    watch: {},
    methods: {
        cancel() {
            this.errors.clear()
            this.$emit('cancel')
        },

        async createOrder() {
            try {
                this.submitting = true
                const model = { ...this.model }

                if (!model.customer_id)
                    throw new Error('Customer Must Be selected')
                if (!model.order_type_id)
                    throw new Error('Order Type Must Be selected')
                if (!model.driver_id) throw new Error('Driver Must Be selected')
                model.schedule_at = this.getScheduleAt(model.date, model.time)
                model.delivery_location_section_id =
                    this.customer && this.customer.location_section_id
                console.log('model', model)
                const valid = await this.$validator.validate()
                if (!valid) {
                    throw new Error('Invalid Entry!!')
                }

                const data = await this.$store.dispatch('orders/create', model)
                this.doToast('Success', 'Order Created!', 'success')

                console.log(data)
                this.$emit('success', data)

                this.model = {
                    order_type_id: null,
                    customer_id: null,
                    driver_id: null,

                    order_template_id: null,
                    date: scheduledDate,
                    time: scheduledTime,
                    signature: false,
                    assets: [],
                    // lat: 18.003713067980094,
                    //  long: -76.7883610725403,
                }
            } catch (err) {
                console.log(err)
                this.doToast('Invalid', err.message, 'danger')
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
